import { render, staticRenderFns } from "./Costs.vue?vue&type=template&id=4c34b82c&scoped=true&"
import script from "./Costs.vue?vue&type=script&lang=ts&"
export * from "./Costs.vue?vue&type=script&lang=ts&"
import style0 from "./Costs.vue?vue&type=style&index=0&id=4c34b82c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c34b82c",
  null
  
)

export default component.exports